var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportView',{attrs:{"title":"Resumen fase certificación"}},[_c('OfficeCertificationReport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }